import React, { FunctionComponent } from 'react';
import { SupportSidebar } from './SupportSidebar';

import styles from './styles.module.scss';

export const SupportPageFrame: FunctionComponent = ({ children }) => {
  return (
    <div className={styles.pageContainer}>
      <SupportSidebar />
      <div className={styles.sideBarOffset} />
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
};
